<template>
  <div class="statistic-info-container">
    <el-row class="statistic-info">
      <el-col :span="12" class="title">
        {{ title }}
      </el-col>
      <el-col :span="12">
        <span class="number">
          {{ number }}
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "StatisticInfoCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    number: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.statistic-info-container {
  padding: 1rem;
  border: 1px solid #eee;
}
.statistic-info {
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .title {
    font-size: 1.2rem;
    font-weight: 500;
  }
  .number {
    width: 100%;
    text-align: right;
    font-size: 2rem;
  }
}
</style>
